import React from 'react';
import Investorsimg from '../../Images/Investors.png';
import Achievements from '../../Images/Achievements.png';

const Investors = () => {
  return (
    <div className="relative w-full bg-black select-none">
      {/* Button Above Image */}
      <button 
        className="absolute left-16 top-40 bg-transparent text-white py-2 px-4 rounded-lg flex items-center space-x-2 w-28 h-12"
      >
        <span className='hidden'>Know More</span>
        {/* Arrow Icon can be added if needed */}
      </button>

      {/* Image */}
      <img 
        src={Investorsimg}
        alt="Partner" 
        className="w-full h-auto"
      />

      <div className='mt-20 '>
        <img
          src={Achievements}
          alt="Achievements"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
};

export default Investors;
